export default "__VITE_ASSET__CQUIBfIK__"